<script>
  import { onMount } from 'svelte';
  import { page, router } from '@inertiajs/svelte';
  import Burger from '../Burger.svelte';
  import GallerySlider from './GallerySlider.svelte';
  import ScrollButton from '$lib/ScrollButton.svelte';

  export let lightbox = {
    scrollable: true,
  };

  let videoEl, initialSlide;

  export function close() {
    if ('video' == lightbox.type) {
      videoEl.pause();
      if (window.location.search.includes('showreel')) {
        const url = new URL(window.location.href);
        url.searchParams.delete('showreel');
        router.visit(url);
      } else {
        lightbox.open = false;
      }
    } else {
      lightbox.open = false;
    }
  }

  export function open(index) {
    initialSlide = index;
    lightbox.open = true;

    if ('video' == lightbox.type) {
      let promise = videoEl.play();
      if (promise !== undefined) {
        promise.then().catch((error) => {
          videoEl.muted = true;
          videoEl.play();
        });
      }
    }
  }

  onMount(() => {
    videoEl.pause();
  });
</script>

<svelte:window
  on:keydown={(e) => {
    if (e.key === 'Escape') {
      close();
    }
  }}
/>

<div id="lightbox" class="lightbox" class:open={lightbox.open}>
  <div class="lightbox__header">
    <img
      src={$page.props.site_logo.dark.src}
      alt="Caballero logo"
      class="lightbox__logo"
    />
    {#if 'image' === lightbox.type && lightbox.image.title}
      <div class="lightbox__title text-small">
        <i class="lightbox__title-icon isax isax-gallery" />
        <span class="lightbox__title-text">
          {lightbox.image.title}
        </span>
      </div>
    {/if}
    <div class="lightbox__close">
      <Burger theme="dark" open={true} on:click={close} />
    </div>
  </div>
  {#if 'video' == lightbox.type}
    <div class="lightbox__content">
      <video
        bind:this={videoEl}
        src={lightbox.items}
        playsinline
        loop
        loading="lazy"
        autoplay
        controls
      />
    </div>
  {:else if 'image' == lightbox.type}
    <div class="lightbox__content">
      <div class="lightbox__image" class:scrollable={lightbox.scrollable}>
        <img
          src={lightbox.image.src}
          alt={lightbox.image.alt}
          height={lightbox.image.height}
          width={lightbox.image.width}
        />
      </div>
      {#if lightbox.scrollable}
        <div class="lightbox__scroll-btn">
          <ScrollButton theme="dark" />
        </div>
      {/if}
    </div>
  {:else if 'gallery' == lightbox.type}
    {#if lightbox.open}
      <GallerySlider images={lightbox.gallery} {initialSlide} />
    {/if}
  {/if}
</div>

<style lang="scss">
  .lightbox {
    pointer-events: none;
    visibility: hidden;
    opacity: 0;

    position: fixed;
    z-index: 100;
    inset: 0;
    overflow: hidden;

    background-color: rgb(var(--white));

    transition: all 0.25s;

    &.open {
      pointer-events: all;
      visibility: visible;
      opacity: 1;
    }

    :global .burger {
      background-color: rgb(var(--white));
    }

    &__header {
      height: 6rem;
      padding: 0 6rem;
      display: flex;
      justify-content: space-between;
      align-items: center;

      @include resp-max('s') {
        padding: 0 1rem;
      }
    }

    &__logo {
      width: 14.3rem;
      height: 3.6rem;
    }

    &__title {
      &-icon {
        font-weight: 700;
      }

      &-text {
        color: var(--royal-light);
      }

      @include resp-max('s') {
        display: none;
      }
    }

    &__content {
      height: calc(100vh - 6rem);

      display: flex;
      align-items: center;
      justify-content: center;

      video {
        max-width: 100%;
        max-height: 100%;
      }
    }

    &__image {
      // height: 100%;
      // width: 100%;

      img {
        // object-fit: contain;
      }
    }

    &__image.scrollable {
      overflow-y: auto;
      width: 38rem;
      height: 57rem;
      border-radius: 1rem;
      outline: solid 1px var(--light-border);
      border: solid 1px $light-border;
      align-self: end;
      padding: 1rem 1rem 0 1rem;

      /* Hide scrollbar for Chrome, Safari and Opera */
      &::-webkit-scrollbar {
        display: none;
      }

      /* Hide scrollbar for IE, Edge and Firefox */

      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
    }

    &__scroll-btn {
      position: absolute;
      right: 5.6rem;
      bottom: 6.7rem;
    }
  }
</style>
